// extracted by mini-css-extract-plugin
module.exports = {"dropdownTitle":"_3Z2lJ6xh","modalBody":"_3NsINssw","dropdown":"_3oKub-le","dropdownMenu":"_25i7gMux","chevronDown":"cZKE0G7_","permissionOption":"_2bLK1etR"};